import RefreshRuntime from '/@react-refresh'

declare global {
  interface Window {
    global: Window
    $RefreshReg$: () => void
    $RefreshSig$: (type?: unknown) => unknown
    __vite_plugin_react_preamble_installed__: boolean
  }
}

window.global = window
if (process.env.NODE_ENV !== 'production') {
  RefreshRuntime.injectIntoGlobalHook(window)
  window.$RefreshReg$ = () => {}
  window.$RefreshSig$ = () => (type) => type
  window.__vite_plugin_react_preamble_installed__ = true
}
